<template>
  <div class="forgot-password flex flex-col">
    <button type="button" class="btn-empty-wrapper mt-5" @click="clickHandler">
      <Close icon="back"></Close>
    </button>
    <ConfirmPhoneNumber 
      v-if="!phoneVerification"
      :title="forgetTitle"
      content="If you need help resetting your password we can help by sending you a link to reset it"
      @next="sendSMS" />
    <PhoneVerification
      v-else
      para-two="continue to reset your password"
      :phone="phoneNumber"
      @sendSMS="sendSMS"
    ></PhoneVerification>
  </div>
</template>

<script>
import Close from "../UI/Close";
import PhoneVerification from "./PhoneVerification";
import ConfirmPhoneNumber from "./ConfirmPhoneNumber.vue"
export default {
  name: "ForgotPassword",

  components: {
    Close,
    ConfirmPhoneNumber,
    PhoneVerification
  },

  props: ["clickHandler"],

  mounted() {
    this.$setState("step_header", false);
    this.phoneVerification = false;
  },

  data: function() {
    return {
      phoneNumber: '',
      phoneVerification: false,
    };
  },
  
  computed: {
    forgetTitle () {
      return ` <span class="text-primary">Forgot</span> 
        <span class="text-content">your Password</span>`
    }
  },

  methods: {
    async sendSMS (phone) {
      this.phoneNumber = phone
      const payload = { phone }
      const res = await this.$http.post("user/checkphone", payload)
      if(!res.status) return
      this.phoneVerification = true
    },
  }
};
</script>